import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-black",
  "use": "icon-arrow-down-black-usage",
  "viewBox": "0 0 26 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 16\" id=\"icon-arrow-down-black\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m23.82.733 2.121 2.121-12.263 12.264a1 1 0 0 1-1.415 0L0 2.854 2.121.734l10.85 10.848L23.82.733Z\" fill=\"#000\" fill-opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol